export enum DentalInterval {
  NEVER = 'NEVER',
  YEARLY = 'YEARLY',
  BIANNUALLY = 'BIANNUALLY',
}

export const getDentalIntervalLabel = (value: DentalInterval): string => {
  switch (value) {
    case DentalInterval.NEVER:
      return $localize`Jamais`;
    case DentalInterval.YEARLY:
      return $localize`1 x par an`;
    case DentalInterval.BIANNUALLY:
      return $localize`2 x par année`;
    default:
      return value;
  }
};

export enum HealthBaseInsurance {
  TELEMEDECINE = 'TELEMEDECINE',
  FAMILY = 'FAMILY',
  HEALTHCARE_NETWORK = 'HEALTHCARE_NETWORK',
  FREE_CHOICE_OF_DOCTOR = 'FREE_CHOICE_OF_DOCTOR',
}

export const getHealthBaseInsuranceLabel = (
  value: HealthBaseInsurance
): string => {
  switch (value) {
    case HealthBaseInsurance.TELEMEDECINE:
      return $localize`Télémedecine`;
    case HealthBaseInsurance.FAMILY:
      return $localize`Famille`;
    case HealthBaseInsurance.HEALTHCARE_NETWORK:
      return $localize`Réseau de santé`;
    case HealthBaseInsurance.FREE_CHOICE_OF_DOCTOR:
      return $localize`Libre choix du médecin`;
    default:
      return value;
  }
};

export enum PaymentMethod {
  BVR = 'BVR',
  LSV = 'LSV',
  DIRECT_DEBIT = 'DIRECT_DEBIT',
  E_BILL = 'E_BILL',
  ELECTRONIC_INVOICE = 'ELECTRONIC_INVOICE',
}

export const getPaymentMethodLabel = (method: PaymentMethod): string => {
  switch (method) {
    case PaymentMethod.BVR:
      return $localize`Bulletin de versement`;
    case PaymentMethod.LSV:
      return $localize`LSV`;
    case PaymentMethod.DIRECT_DEBIT:
      return $localize`Débit direct`;
    case PaymentMethod.E_BILL:
      return $localize`eBill`;
    case PaymentMethod.ELECTRONIC_INVOICE:
      return $localize`E-facture`;
    default:
      return method;
  }
};

export enum HospitalInsuranceEnum {
  GENERAL = 'GENERAL',
  SEMI_PRIVATE = 'SEMI_PRIVATE',
  PRIVATE = 'PRIVATE',
  NONE = 'NONE',
}

export const getHospitalInsuranceLabel = (
  value: HospitalInsuranceEnum
): string => {
  switch (value) {
    case HospitalInsuranceEnum.GENERAL:
      return $localize`Division commune`;
    case HospitalInsuranceEnum.SEMI_PRIVATE:
      return $localize`Demi-privée`;
    case HospitalInsuranceEnum.PRIVATE:
      return $localize`Privée`;
    case HospitalInsuranceEnum.NONE:
      return $localize`Sans assurance hospitalisation`;
    default:
      return value;
  }
};

export enum HealthPrestationsEnum {
  FITNESS = 'FITNESS',
  MASSAGE = 'MASSAGE',
  EYEWEAR = 'EYEWEAR',
  LEGAL_PROTECTION = 'LEGAL_PROTECTION',
  REPATRIATION = 'REPATRIATION',
  RESCUE = 'RESCUE',
  CHECK_UP = 'CHECK_UP',
  DENTAL = 'DENTAL',
  HYGIENIST = 'HYGIENIST',
}

export const getHealthPrestationsLabel = (
  value: HealthPrestationsEnum
): string => {
  switch (value) {
    case HealthPrestationsEnum.FITNESS:
      return $localize`Fitness`;
    case HealthPrestationsEnum.MASSAGE:
      return $localize`Massage`;
    case HealthPrestationsEnum.EYEWEAR:
      return $localize`Lunettes`;
    case HealthPrestationsEnum.LEGAL_PROTECTION:
      return $localize`Protection juridique`;
    case HealthPrestationsEnum.REPATRIATION:
      return $localize`Rapatriement`;
    case HealthPrestationsEnum.RESCUE:
      return $localize`Secours`;
    case HealthPrestationsEnum.CHECK_UP:
      return $localize`Check-up`;
    case HealthPrestationsEnum.DENTAL:
      return $localize`Dentaire`;
    case HealthPrestationsEnum.HYGIENIST:
      return $localize`Hygiéniste`;
    default:
      return value;
  }
};

export enum CivilStatus {
  SINGLE = 'SINGLE',
  MARRIED = 'MARRIED',
  DIVORCED = 'DIVORCED',
  WIDOWED = 'WIDOWED',
  REGISTERED_PARTNERSHIP = 'REGISTERED_PARTNERSHIP',
  DISSOLVED_PARTNERSHIP = 'DISSOLVED_PARTNERSHIP',
  SEPARATED = 'SEPARATED',
  UNKNOWN = 'UNKNOWN',
}

export const getCivilStatusLabel = (status: CivilStatus): string => {
  switch (status) {
    case CivilStatus.SINGLE:
      return $localize`Célibataire`;
    case CivilStatus.MARRIED:
      return $localize`Marié(e)`;
    case CivilStatus.DIVORCED:
      return $localize`Divorcé(e)`;
    case CivilStatus.WIDOWED:
      return $localize`Veuf(ve)`;
    case CivilStatus.REGISTERED_PARTNERSHIP:
      return $localize`Partenariat enregistré`;
    case CivilStatus.DISSOLVED_PARTNERSHIP:
      return $localize`Partenariat dissout`;
    case CivilStatus.SEPARATED:
      return $localize`Séparé(e)`;
    case CivilStatus.UNKNOWN:
      return $localize`Inconnu`;
    default:
      return '';
  }
};
